import type {
    GetFormAnswersForAdminResponseType,
    GetFormAnswersForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const getFormAnswersForAdmin = async (
    payload: GetFormAnswersForAdminRequestType
): Promise<GetFormAnswersForAdminResponseType> => {
    return await request<GetFormAnswersForAdminResponseType>(`/events/getFormAnswers?formID=${payload.formID}`, {
        method: "GET"
    });
};

export default getFormAnswersForAdmin;
